// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ps-customizer-area[data-v-f5b07006]{position:sticky;top:50px;max-height:calc(100vh - 50px)}.rotate_class[data-v-f5b07006]{-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease}", ""]);
// Exports
module.exports = exports;
